import React from "react";
import ScriptProvider from "./ScriptProvider";
import { isPointedToProd } from "./mosaic/point-to-prod";
import PointToProdIndicator from "./mosaic/PointToProdIndicator";
import { getMosaicLocation } from "./mosaic/path";

const MosaicProvider = (props) => {
  const onLoad = () => {
    return window.Jigsaw.init(window.location.hostname);
  };

  return (
    <ScriptProvider src={getMosaicLocation()} onLoad={onLoad}>
      {props.children}
      {isPointedToProd() && <PointToProdIndicator />}
    </ScriptProvider>
  );
};

export default MosaicProvider;
